import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { GlobalComponent } from 'src/app/global/global.component';
import { map} from 'rxjs/operators';
import { GetClientEvaluation } from './budgetimport.model';
import { GeneralService } from 'src/app/service/general.service';

@Injectable({
  providedIn: 'root'
})

export class budgetlistService extends Subject<DataStateChangeEventArgs> {
  constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService) {
    super();
  }

  public exceuteOnboardEmployee(state: GetClientEvaluation): void {
    this.getOnboardData(state).subscribe(x => super.next(x));
  }
  getOnboardData(state?: GetClientEvaluation): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Budget/GeBudgetListFilter", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }

  public exceuteOnboardClient(state: GetClientEvaluation): void {
    this.getOnboardDataClient(state).subscribe(x => super.next(x));
  }

  getOnboardDataClient(state?: GetClientEvaluation): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Client_Budget/GeBudgetListFilter", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }
}